import {
  Nav,
  NavDropdown,
  Carousel,
  Container,
  Form,
  Button,
  Modal,
  Col,
  Row,
  ListGroup,
  Image,
  NavItem,
  NavLink,
} from "react-bootstrap";
import React, { Link, useParams, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getHighlightedNews,
  searchAnalysisInCategory,
  tutoriaisS,
  findNewsRecents

} from "../../services/api";

import "./styles.scss";
import { GoChevronDown } from "react-icons/go";
import { BiSortDown, BiSortUp } from "react-icons/bi";
import LoadingIndicator from "../../components/LoadingIndicator";
import Footer from "../../components/Footer";
import debounce from "lodash.debounce";

import { Helmet } from "react-helmet";
import { textEllipsis, timeAgo } from "../../utils/mappers";
import qs from "qs";
import CardNews from "../../components/CardNews";
import Loader from "../../components/Loader/Loader";
import { useSearch } from '../../contexts/SearchContext'
import VideoCarousel from "../../components/videos";
import CardAnalises from "../../components/CardAnalises";
export default function Marketplace({ match, location }) {
  const [categorySelected, setCategorySelected] = useState("Todas as categorias");
  const [query, setQuery] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [page, setPage] = useState();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [tutoriais, setTutoriais] = useState(null);
  const [status, setStatus] = useState("loading");
  const history = useHistory();
  const { idCategory } = useParams();
  const { debouncedSearchTerm } = useSearch();
  const [lastCategory, setLastCategory] = useState(idCategory);
  const [ascOrDesc, setAscOrDesc] = useState("DESC");
  const [highlights, setHighlights] = useState(null);
  const [loadingHighlights, setLoadingHighlights] = useState(true);
  const [loadingT, setLoadingT] = useState(true);
  const [newsR, setNewsR] = useState([]);
  const q = qs.parse(location.search, { ignoreQueryPrefix: true }).q;
  const googleAd = {
    imageUrl: "https://via.placeholder.com/300x600", // Substitua pelo link correto da imagem do anúncio
    url: "https://google.com" // Substitua pelo URL do anúncio
  };


  useEffect(() => {
    const p = sessionStorage.getItem("@app_mercadim:p");
    if (p) {
      setPage(Number(p));
    }
  }, []);

  useEffect(() => {
    const pageType = "Análises";

    getHighlightedNews(pageType).then((data) => {
      setHighlights(data);
      setLoadingHighlights(false);
    });

    findNewsRecents().then((data) => {
      setNewsR(data);
    });

    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    if (q && debouncedSearchTerm.length === 0) {
      const payload = {
        name: q,


      };
      tutoriaisS(payload, page, ascOrDesc).then((data) => {
        setTutoriais(data);
        setLoadingT(false);
      });
    } else {
      const dados = {
        name: debouncedSearchTerm,


      };
      tutoriaisS(dados, page, ascOrDesc).then((data) => {
        setTutoriais(data);
        setLoadingT(false);
      });
    }
  }, [page, debouncedSearchTerm, ascOrDesc, q]);

  useEffect(() => {

    /*setTimeout(async () => {*/
    if (lastCategory) {

      const payload = {
        nameNews: debouncedSearchTerm,
        category_id: lastCategory,
        ...(!showAll),
      };

      searchAnalysisInCategory(payload, page, ascOrDesc).then((data) => {
        setResults((prev) => {
          // Supondo que cada produto tenha um campo 'id' único
          const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
          return [...prev, ...updatedData];
        });

        setStatus("result");
      });
    } else {
      setCategorySelected("Categorias");

      if (q && debouncedSearchTerm.length === 0) {
        const payload = {
          nameNews: q,
          category_id: lastCategory,
          ...(!showAll),
        };
        searchAnalysisInCategory(payload, page, ascOrDesc).then((data) => {
          setResults((prev) => {
            // Supondo que cada produto tenha um campo 'id' único
            const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
            return [...prev, ...updatedData];
          });
          setStatus("result");
        });
      } else {
        const dados = {
          nameNews: debouncedSearchTerm,
          category_id: lastCategory,
          ...(!showAll),
        };
        searchAnalysisInCategory(dados, page, ascOrDesc).then((data) => {
          setResults((prev) => {
            // Supondo que cada produto tenha um campo 'id' único
            const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
            return [...prev, ...updatedData];
          });
          setStatus("result");
        });
      }
    }

  }, [lastCategory, page, debouncedSearchTerm, ascOrDesc, showAll, q]);

  useEffect(() => {
    if (lastCategory !== idCategory) {
      setLastCategory(idCategory);
      setPage(0); // Reinicia a paginação
      setResults([]); // Limpa os resultados existentes
      setStatus("loading");
    }
  }, [lastCategory, idCategory]);
  useEffect(() => {
    sessionStorage.setItem("@app_mercadim:q", debouncedSearchTerm);
    setPage(1); // Reinicia a paginação
    setResults([]); // Limpa os resultados existentes
    setStatus("loading");
  }, [debouncedSearchTerm]);
  useEffect(() => {
    if (!q) {
      sessionStorage.setItem("@app_mercadim:p", page);

    }
  }, [page, q]);



  function renderResults() {

    if (status !== "result") {
      return null;
    }

    if (results.length === 0) {
      return (
        <>
          <Container>
            <Row>
              <Col className="my-5">
                <h5 className="text-muted text-center my-5">Sem resultados</h5>
              </Col>
            </Row>
          </Container>
        </>
      );
    }

    return (
      <>
        <Container fluid>
          <Row className="">
            <Col md={8} className="mt-3">
              <h2>Últimas Análises</h2>
              <div className="news-cards-wrapper">
                {results.map((newsItem, index) => (
                  <div key={index} className="card-wrapper">
                    <CardAnalises newsItem={newsItem} />
                  </div>
                ))}
              </div>

              <div className="d-flex justify-content-center mt-4">
                <Button className="btn-ver-mais" onClick={() => {
                  if (status !== "loading") { // Verifica se o status não é 'result'
                    setStatus("result"); // Muda para 'loading' para iniciar o carregamento
                    setPage(prev => prev + 1); // Incrementa a página para carregar mais conteúdo
                  }
                }}>
                  Ver mais...
                </Button>



              </div>
            </Col>
            <Col md={4} className="mt-3">
              <h2 className="mb-3">Mais Recentes</h2>
              {newsR.slice(0, 4).map((item, index) => (
                <CardNews key={index} newsItem={item} small />
              ))}
            </Col>

          </Row>

        </Container>
      </>
    );


  }



  return (
    <>
      <Helmet title="Caçadores de Ofertas: Marketplace" />

      <div className="marketplace-main-wrapper">
        {!loadingHighlights && highlights && highlights.length > 0 && (
          <Container fluid className="px-0">
            <h2 className="highlights-title px-3"></h2>
            <div className="row m-0">
              <Carousel className="carousel-full-width" controls indicators interval={6000} pause={false}>
                {highlights.map((h) => (
                  <Carousel.Item key={h.id}>
                    <div className="carousel-image-wrapper-natural">
                      <Link to={`/new/${h.slug}`} className="highlight-link">
                        <Image
                          src={h.image_url}
                          alt={h.name}
                          className="carousel-image-natural"
                          fluid
                        />
                      </Link>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </Container>
        )}
        <Container fluid>
          <div style={{ margin: "40px" }}></div>
          {renderResults()}
          {status === "loading" && <Loader />}
          {/*!loadingT && tutoriais && tutoriais.length > 0 && (<VideoCarousel videos={tutoriais} />)*/}
          <div style={{ margin: "80px" }}></div>
        </Container>
      </div>
      <Footer />
    </>
  );

}




